import React from 'react';
/* eslint-disable no-nested-ternary */
import { FormikConfig, FormikProps, FormikProvider, FormikValues, isEmptyChildren, isFunction } from 'formik';

import { useFormikErrorTracker, useFormikSessionStorage } from './FormikWrapper.methods';

export type FormikWrapperProps<Values> = FormikConfig<Values> & {
  /** Key to store session */
  // eslint-disable-next-line react/no-unused-prop-types
  formikSessionStateKey?: string;
};

/** Customer wrapper around Formik; enabling ability to store as session and for tracking.
 * @remarks This is an extended copy of the JSX Formik wrapper.
 */
export default function FormikWrapper<Values extends FormikValues = FormikValues>(props: FormikWrapperProps<Values>) {
  // *** START Custom hooks ***
  // const formikbag = useFormik<Values>(props);
  const formikbag = useFormikSessionStorage(props);
  useFormikErrorTracker(formikbag.errors);
  // *** END Custom hooks ***

  const { component, children, render, innerRef } = props;

  // This allows folks to pass a ref to <Formik />
  React.useImperativeHandle(innerRef, () => formikbag);

  return (
    <FormikProvider value={formikbag}>
      {component
        ? React.createElement(component as any, formikbag)
        : render
        ? render(formikbag)
        : children // children come last, always called
        ? isFunction(children)
          ? (children as (bag: FormikProps<Values>) => React.ReactNode)(formikbag as FormikProps<Values>)
          : !isEmptyChildren(children)
          ? React.Children.only(children)
          : null
        : null}
    </FormikProvider>
  );
}
